/**
 * Used to defer non-critical observability work (i.ESentry profiling)
 * off the synchronous boot path.
 */
export const scheduleIdle = (
  fn: () => void,
  timeoutMs: number = 2000
): void => {
  if (
    typeof window !== 'undefined' &&
    typeof window.requestIdleCallback === 'function'
  ) {
    window.requestIdleCallback(fn, { timeout: timeoutMs });
  } else {
    setTimeout(fn, 1);
  }
};
